import React from "react";
import PropTypes from "prop-types";
import { BiBarChart, BiBrain, BiLineChart } from "react-icons/bi"; // Import valid icons
import "./FeatureSection1.css";

const features = [
  {
    icon: <BiBarChart />,
    title: "Real-Time Monitoring",
    description: "Track plant voltage signals with high precision.",
  },
  {
    icon: <BiBrain />,
    title: "Emotion Mapping",
    description: "AI correlates plant signals with human emotions.",
  },
  {
    icon: <BiLineChart />,
    title: "Data Visualization",
    description: "Visualize correlations between emotions and plant responses.",
  },
];

const FeatureCard = ({ icon, title, description }) => (
  <div className="feature-card" tabIndex="0" aria-label={title}>
    <div className="feature-icon">{icon}</div>
    <h3 className="feature-title">{title}</h3>
    <p className="feature-description">{description}</p>
  </div>
);

FeatureCard.propTypes = {
  icon: PropTypes.element.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

const FeatureSection1 = ({ sectionTitle = "Our Features", sectionSubtitle = "" }) => (
  <section className="feature-section">
    <div className="feature-header">
      <h2 className="title">{sectionTitle}</h2>
      {sectionSubtitle && <p className="section-subtitle">{sectionSubtitle}</p>}
    </div>
    <div className="feature-grid">
      {features.map((feature, index) => (
        <FeatureCard key={index} {...feature} />
      ))}
    </div>
  </section>
);

FeatureSection1.propTypes = {
  sectionTitle: PropTypes.string,
  sectionSubtitle: PropTypes.string,
};

export default FeatureSection1;
